export { default as EmbeddedMap } from './EmbeddedMap'
export { default as Footer } from 'components/shared/footer/Footer'
export { default as GoogleTagManager } from './GoogleTagManager'
export { default as HostSummary } from './HostSummary'
export { default as Pager } from './Pager'
export { default as SelectSort } from './SelectSort'



// WEBPACK FOOTER //
// ./src/components/shared/index.jsx